<span
  class="consultant-card-icon-wrapper"
  [ouiTooltip]="statusLabel()"
  ouiTooltipPosition="top">
  <oui-icon class="consultant-card-icon consultant-card-icon--{{ tagStatus() }}"> business_center </oui-icon>
</span>
<div class="consultant-card-content">
  <div class="consultant-card-header body-2">
    {{ code() }}
    @if (id() !== null && id() !== undefined) {
      • #{{ id() }}
    }
  </div>
  <div class="consultant-card-body">
    @if (link()) {
      <a
        class="consultant-card-name subtitle-1"
        target="_blank"
        [routerLink]="link()"
        >{{ name() }}</a
      >
    } @else {
      <span class="consultant-card-name subtitle-1">{{ name() }}</span>
    }
  </div>
</div>
